import styles from './EncounterTemplateOverviewPanel.module.scss';
import { Button, Spin, Typography } from 'antd';
import { RtkqSpin, useBool } from '@app/base';
import { useGetEncounterTemplateQuery, EncounterTemplate } from '@app/medical-record/api';
import { EncounterTemplateOverviewContent } from './EncounterTemplateOverviewContent';
import { Icon } from '@app/ui';
import { EncounterTemplateDetailsPanel } from './EncounterTemplateDetailsPanel';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

interface Props {
  templateId: string;
  onApply?: (template: EncounterTemplate) => void;
  disabledApplyBtn?: boolean;
  className?: string;
  editable?: boolean;
}

export function EncounterTemplateOverviewPanel(props: Props) {
  const { templateId, className, editable } = props;
  const { t } = useTranslation();
  const { data: template, isFetching } = useGetEncounterTemplateQuery({ id: templateId, [RtkqSpin]: false });
  const [editMode, , toggleEditMode] = useBool(false);

  if (isFetching)
    return (
      <div className="w-full text-center my-5">
        <Spin />
      </div>
    );

  if (editMode) {
    return (
      <EncounterTemplateDetailsPanel
        onSubmitted={toggleEditMode}
        templateId={templateId}
        richTextAreaClassname={styles.richTextArea}
        actions={<Button onClick={toggleEditMode}>{t('cancel')}</Button>}
      />
    );
  }

  if (!template) {
    return null;
  }

  return (
    <EncounterTemplateOverviewContent
      {...props}
      template={template}
      title={
        <div className="w-full flex justify-between items-center">
          <Title level={5} className="mt-2">
            {template.name}
          </Title>
          {editable && (
            <Button onClick={toggleEditMode} type="link" icon={<Icon type="edit" />} aria-label={t('edit')} />
          )}
        </div>
      }
      className={className}
    />
  );
}
